import { cGame } from "./creator/cGame";
import { logging } from "./creator/utils/logging"


export const applyStates = (stateName) =>{
  
  switch (String(stateName).toLowerCase()){
    case 'poster':
      cGame.current.state.set('2::wahl_game_state','poster')
      cGame.current.state.set('2::badge_completed','1')
      break;
    case 'wahlomat':
      cGame.current.state.set('2::wahl_game_state','explore')
      cGame.current.state.set('2::badge_completed','1')
      break;
    case 'poster':
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'poster_qpd':
      cGame.current.state.set('2::selected_party','qpd')
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'poster_pas':
      cGame.current.state.set('2::selected_party','pas')
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'poster_tuba':
      cGame.current.state.set('2::selected_party','tuba')
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'poster_bunte':
      cGame.current.state.set('2::selected_party','bunte')
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'poster_ulf':
      cGame.current.state.set('2::selected_party','ulf')
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'poster_dds':
      cGame.current.state.set('2::selected_party','dds')
      cGame.current.state.set('2::wahl_game_state','poster_start')
      break;
    case 'sunday':
      cGame.current.state.set('2::wahl_game_state','go_home')
      break;
    case 'setup':
      cGame.current.state.set('2::wahl_game_state','setup')
      break;
    case 'shed':
      cGame.current.state.set('2::wahl_game_state','election_day_code')
      break;
    case 'find':
      cGame.current.state.set('2::wahl_game_state','valentina_find')
      break;
    case 'home':
      cGame.current.state.set('2::wahl_game_state','home_after_election')
      break;


    case 'voiceover':
      cGame.current.state.set('voiceover','on')
      break;
    case 'voiceoff':
      cGame.current.state.remove('voiceover')
      break;

      
    default:
      logging.error('STATE NOT FOUND:',stateName)
  }
  


}